import { Button } from '@/shared/components/shadcn/button';

type CampaignEditorFooterAction = {
  disabled?: boolean;
  label: string;
  onClick: () => void;
};

type CampaignEditorFooterProps = {
  message: string;
  primaryAction: CampaignEditorFooterAction;
  secondaryAction?: CampaignEditorFooterAction;
  usageLabel?: string;
};

export function CampaignEditorFooter({
  message,
  primaryAction,
  secondaryAction,
  usageLabel,
}: CampaignEditorFooterProps) {
  return (
    <>
      <div className="min-w-0 space-y-1 text-left">
        <p className="text-muted-foreground text-sm">{message}</p>
        {usageLabel ? (
          <p className="text-foreground text-sm font-medium">{usageLabel}</p>
        ) : null}
      </div>
      <div className="flex items-center gap-3">
        {secondaryAction ? (
          <Button
            type="button"
            variant="outline"
            disabled={secondaryAction.disabled}
            onClick={secondaryAction.onClick}
          >
            {secondaryAction.label}
          </Button>
        ) : null}
        <Button
          type="button"
          disabled={primaryAction.disabled}
          onClick={primaryAction.onClick}
        >
          {primaryAction.label}
        </Button>
      </div>
    </>
  );
}
